import '../../title.css';
import '../../../app.css';

const React = require('react');
const ModalWindow = require('../../../../core/modal').default;
const { applicationStyle } = require('../../../app.style').default;
const assets = require('../../../../assets').default;
const player = require('../../../../define/player').default;
const { sound, soundType } = require('../../../../core/sound').default;
// ============================

const selectStyle = {
    width: (applicationStyle.width * 0.95)
}

const getSkillAreaImage = (type) => {
    switch (type) {
        case player.PLAYER_ROYAL_GUARD:
            return assets.SkillAreaRG;
        case player.PLAYER_KAGEROU:
            return assets.SkillAreaKG;
        case player.PLAYER_SUMMONER:
            return assets.SkillAreaSM;
        default:
            return;
    }
}

export default class selectComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            select: player.PLAYER_ROYAL_GUARD,
            name: ""
        }
        this.handleInput = this.handleInput.bind(this);
    }


    isSelected(type) {
        if (this.state.select === type) {
            return 'pink';
        }
        return 'white';
    }

    handleInput(event) {
        this.setState({ name: event.target.value });
    }

    renderSkillArea() {
        const playerData = player.getPlayerData(this.state.select);
        return (
            <div className="select-skill-text">
                <div className="select-skill-text-row">
                    <div className="select-skill-text-head">JOB</div>
                    <div className="select-skill-text-cell">{playerData.playerName}</div>
                </div>
                <div className="select-skill-text-row">
                    <div className="select-skill-text-head">SKILL</div>
                    <div className="select-skill-text-cell">{playerData.skillName}</div>
                </div>
                <div className="select-skill-text-row">
                    <div className="select-skill-text-head">ATK</div>
                    <div className="select-skill-text-cell">x{playerData.skillDamage}</div>
                </div>
                <div className="select-skill-text-row">
                    <div className="select-skill-text-head">COOL TIME</div>
                    <div className="select-skill-text-cell">{playerData.skillCoolTime} sec</div>
                </div>
                <div className="select-skill-text-row">
                    <div className="select-skill-text-head">AREA</div>
                    <div className="select-skill-text-cell">
                        <img src={getSkillAreaImage(this.state.select)} />
                    </div>
                </div>
            </div>
        )
    }

    renderContents() {
        return (
            <div style={selectStyle}>
                <div className="dialog">
                    <div className="dialog-header-bg">
                        <div className="dialog-header">Charactor Select</div>
                    </div>
                    <div className="dialog-contents">
                        <div className="select-row">
                            <div className="select-frame"
                                style={{ backgroundColor: this.isSelected(player.PLAYER_ROYAL_GUARD) }}
                                onClick={() => this.setState({ select: player.PLAYER_ROYAL_GUARD })}>
                                <img src={assets.CharactorRG} className="select-img" />
                            </div>
                            <div className="select-frame"
                                style={{ backgroundColor: this.isSelected(player.PLAYER_KAGEROU) }}
                                onClick={() => this.setState({ select: player.PLAYER_KAGEROU })}>
                                <img src={assets.CharactorKG} className="select-img" />
                            </div>
                            <div className="select-frame"
                                style={{ backgroundColor: this.isSelected(player.PLAYER_SUMMONER) }}
                                onClick={() => this.setState({ select: player.PLAYER_SUMMONER })}>
                                <img src={assets.CharactorSM} className="select-img" />
                            </div>
                        </div>

                        <div className="select-row">
                            <div className="select-skill-area" >
                                {this.renderSkillArea()}
                            </div>
                            <div className="select-name-area">
                                <div>NAME</div>
                                <input className="select-name" maxLength={8} id="porin" type="text" name={this.state.name} onChange={this.handleInput} />
                                <div className="select-button">
                                    {this.state.name.length > 0
                                        ? <div className="btn-radius-solid" onClick={() => {
                                            sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                                            this.props.handleStartClick(this.state.select, this.state.name)
                                        }}>GAME START</div>
                                        : <div className="btn-radius-solid-disable">GAME START</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="modal-footer-buttons">
                            <div className="btn-modal" onClick={() => {
                                sound.playSound(soundType.SE_SELECT_SYSTEM, this.props.soundEnable)
                                this.props.handleBackClick()
                            }}>戻る</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        return <ModalWindow
            isModalOpen={this.props.isModalOpen}
            closeRequest={this.props.handleBackClick}
            isCloseOutOfArea={false}
            contents={this.renderContents()}
        />
    }
}